/*=========================================================================================
	File Name: analyticsData.vue
	Description: Data shown by charts
	----------------------------------------------------------------------------------------
	Item Name: Vuesax Admin - VueJS Dashboard Admin Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

const themeColors = ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E'];
 
const market = '$';

export default {
  appConf: {
      currency: market
  },
    // LINE CHART
    siteTraffic: {
        series: [{
            name: 'Traffic Rate',
            data: [150, 200, 125, 225, 200, 250]
        }],
        chartOptions: {
            grid: {
                show: false,
                padding: {
                    left: 0,
                    right: 0
                }
            },
            chart: {
                type: 'line',
                dropShadow: {
                    enabled: true,
                    top: 5,
                    left: 0,
                    blur: 4,
                    opacity: 0.10,
                },
                toolbar: {
                    show: false,
                },
                sparkline: {
                    enabled: true
                }
            },
            stroke: {
                width: 5,
                curve: 'smooth'
            },
            xaxis: {
                type: 'numeric',
            },
            colors: ['#7367F0'],
            fill: {
                type: 'gradient',
                gradient: {
                    shade: 'dark',
                    gradientToColors: ['#A9A2F6'],
                    shadeIntensity: 1,
                    type: 'horizontal',
                    opacityFrom: 1,
                    opacityTo: 1,
                    stops: [0, 100, 100, 100]
                },
            },
            markers: {
                size: 0,
                hover: {
                    size: 5
                }
            },
            tooltip: {
                x: { show: false }
            },
        }
    },
    activeUsers: {
        series: [{
            name: 'Active Users',
            data: [750, 1000, 900, 1250, 1000, 1200, 1100]
        }],
        chartOptions: {
            grid: {
                show: false,
                padding: {
                    left: 0,
                    right: 0
                }
            },
            chart: {
                type: 'line',
                dropShadow: {
                    enabled: true,
                    top: 5,
                    left: 0,
                    blur: 4,
                    opacity: 0.10,
                },
                toolbar: {
                    show: false,
                },
                sparkline: {
                    enabled: true
                }
            },
            stroke: {
                width: 5,
                curve: 'smooth'
            },
            xaxis: {
                type: 'numeric',
            },
            colors: ['#28C76F'],
            fill: {
                type: 'gradient',
                gradient: {
                    shade: 'dark',
                    gradientToColors: ['#55DD92'],
                    shadeIntensity: 1,
                    type: 'horizontal',
                    opacityFrom: 1,
                    opacityTo: 1,
                    stops: [0, 75, 100, 100]
                },
            },
            markers: {
                size: 0,
                hover: {
                    size: 5
                }
            },
            tooltip: {
                x: { show: false }
            },
        }
    },
    newsletter: {
        series: [{
            name: 'Newsletter',
            data: [365, 390, 365, 400, 375, 400]
        }],
        chartOptions: {
            grid: {
                show: false,
                padding: {
                    left: 0,
                    right: 0
                }
            },
            chart: {
                type: 'line',
                dropShadow: {
                    enabled: true,
                    top: 5,
                    left: 0,
                    blur: 4,
                    opacity: 0.10,
                },
                toolbar: {
                    show: false,
                },
                sparkline: {
                    enabled: true
                }
            },
            stroke: {
                width: 5,
                curve: 'smooth'
            },
            xaxis: {
                type: 'numeric',
            },
            colors: ['#FF9F43'],
            fill: {
                type: 'gradient',
                gradient: {
                    shade: 'dark',
                    gradientToColors: ['#ffc085'],
                    shadeIntensity: 1,
                    type: 'horizontal',
                    opacityFrom: 1,
                    opacityTo: 1,
                    stops: [0, 75, 100, 100]
                },
            },
            markers: {
                size: 0,
                hover: {
                    size: 5
                }
            },
            tooltip: {
                x: { show: false }
            },
        }
    },
    revenueComparisonLine: {
        series: [{
                name: "This Month",
                data: [45000, 47000, 44800, 47500, 45500, 48000, 46500, 48600]
            },
            {
                name: "Last Month",
                data: [46000, 48000, 45500, 46600, 44500, 46500, 45000, 47000]
            }
        ],
        chartOptions: {
            chart: {
                toolbar: { show: false },
            },
            stroke: {
                curve: 'smooth',
                dashArray: [0, 8],
                width: [4, 2],
            },
            grid: {
                borderColor: '#e7e7e7',
            },
            legend: {
                show: false,
            },
            colors: ['#F97794', '#b8c2cc'],
            fill: {
                type: 'gradient',
                gradient: {
                    shade: 'dark',
                    inverseColors: false,
                    gradientToColors: ['#7367F0', '#b8c2cc'],
                    shadeIntensity: 1,
                    type: 'horizontal',
                    opacityFrom: 1,
                    opacityTo: 1,
                    stops: [0, 100, 100, 100]
                },
            },
            markers: {
                size: 0,
                hover: {
                    size: 5
                }
            },
            xaxis: {
                labels: {
                    style: {
                        cssClass: 'text-grey fill-current',
                    }
                },
                axisTicks: {
                    show: false,
                },
                categories: ['01', '05', '09', '13', '17', '21', '26', '31'],
                axisBorder: {
                    show: false,
                },
            },
            yaxis: {
                tickAmount: 5,
                labels: {
                    style: {
                        cssClass: 'text-grey fill-current',
                    },
                    formatter: function(val) {
                        return val > 999 ? (val / 1000).toFixed(1) + 'k' : val;
                    }
                }
            },
            tooltip: {
                x: { show: false }
            }
        }
    },

    // LINE AREA CHART
    subscribersGained: {
        series: [{
            name: 'Subscribers',
            data: [28, 40, 36, 52, 38, 60, 55]
        }],
        chartOptions: {
            grid: {
                show: false,
                padding: {
                    left: 0,
                    right: 0
                }
            },
            chart: {
                toolbar: {
                    show: false,
                },
                sparkline: {
                    enabled: true
                }
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'smooth',
                width: 2.5
            },
            fill: {
                type: 'gradient',
                gradient: {
                    shadeIntensity: 0.9,
                    opacityFrom: 0.7,
                    opacityTo: 0.5,
                    stops: [0, 80, 100]
                }
            },
            xaxis: {
                type: 'numeric',
                lines: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                },
                labels: { show: false }
            },
            yaxis: [{
                y: 0,
                offsetX: 0,
                offsetY: 0,
                padding: { left: 0, right: 0 },
            }],
            tooltip: {
                x: { show: false }
            },
        },
    },
    quarterlySales: {
        series: [{
            name: 'Sales',
            data: [10, 15, 7, 12, 3, 16]
        }],
        chartOptions: {
            grid: {
                show: false,
                padding: {
                    left: 0,
                    right: 0
                }
            },
            chart: {
                toolbar: {
                    show: false,
                },
                sparkline: {
                    enabled: true
                }
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'smooth',
                width: 2.5
            },
            fill: {
                type: 'gradient',
                gradient: {
                    shadeIntensity: 0.9,
                    opacityFrom: 0.7,
                    opacityTo: 0.5,
                    stops: [0, 80, 100]
                }
            },
            xaxis: {
                type: 'numeric',
                lines: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                },
                labels: { show: false }
            },
            yaxis: [{
                y: 0,
                offsetX: 0,
                offsetY: 0,
                padding: { left: 0, right: 0 },
            }],
            tooltip: {
                x: { show: false }
            },
        },
    },
    revenueGenerated: {
        series: [{
            name: 'Revenue',
            data: [350, 275, 400, 300, 350, 300, 450]
        }],
        chartOptions: {
            grid: {
                show: false,
                padding: {
                    left: 0,
                    right: 0
                }
            },
            chart: {
                toolbar: {
                    show: false,
                },
                sparkline: {
                    enabled: true
                }
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'smooth',
                width: 2.5
            },
            fill: {
                type: 'gradient',
                gradient: {
                    shadeIntensity: 0.9,
                    opacityFrom: 0.7,
                    opacityTo: 0.5,
                    stops: [0, 80, 100]
                }
            },
            xaxis: {
                type: 'numeric',
                lines: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                },
                labels: { show: false }
            },
            yaxis: [{
                y: 0,
                offsetX: 0,
                offsetY: 0,
                padding: { left: 0, right: 0 },
            }],
            tooltip: {
                x: { show: false }
            },
        },
    },
    ordersRecevied: {
        series: [{
            name: 'Orders',
            data: [10, 15, 8, 15, 7, 12, 8]
        }],
        chartOptions: {
            grid: {
                show: false,
                padding: {
                    left: 0,
                    right: 0
                }
            },
            chart: {
                toolbar: {
                    show: false,
                },
                sparkline: {
                    enabled: true
                }
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'smooth',
                width: 2.5
            },
            fill: {
                type: 'gradient',
                gradient: {
                    shadeIntensity: 0.9,
                    opacityFrom: 0.7,
                    opacityTo: 0.5,
                    stops: [0, 80, 100]
                }
            },
            xaxis: {
                type: 'numeric',
                lines: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                },
                labels: { show: false }
            },
            yaxis: [{
                y: 0,
                offsetX: 0,
                offsetY: 0,
                padding: { left: 0, right: 0 },
            }],
            tooltip: {
                x: { show: false }
            },
        },
    },
    // BAR CHART
    salesBar: {
        series: [{
            name: 'Sessions',
            data: [75, 125, 225, 175, 125, 75, 25]
        }],
        chartOptions: {
            grid: {
                show: false,
                padding: {
                    left: 0,
                    right: 0
                }
            },
            chart: {
                type: 'bar',
                sparkline: { enabled: true },
                toolbar: { show: false },
            },
            states: {
                hover: {
                    filter: 'none'
                }
            },
            colors: ['#e6edf7', '#e6edf7', '#7367f0', '#e6edf7', '#e6edf7', '#e6edf7'],
            plotOptions: {
                bar: {
                    columnWidth: '45%',
                    distributed: true,
                    endingShape: 'rounded', // Deprecated
                    // borderRadius: '20px', // Coming Soon
                }
            },
            tooltip: {
                x: { show: false }
            },
        }
    },
    // RADIAL BAR
    goalOverviewRadialBar: {
        series: [23],
        chartOptions: {
            plotOptions: {
                radialBar: {
                    size: 110,
                    startAngle: -150,
                    endAngle: 150,
                    hollow: {
                        size: '77%',
                    },
                    track: {
                        background: "#bfc5cc",
                        strokeWidth: '50%',
                    },
                    dataLabels: {
                        name: {
                            show: false
                        },
                        value: {
                            offsetY: 18,
                            color: '#99a2ac',
                            fontSize: '4rem'
                        }
                    }
                }
            },
            colors: ['#00db89'],
            fill: {
                type: 'gradient',
                gradient: {
                    shade: 'dark',
                    type: 'horizontal',
                    shadeIntensity: 0.5,
                    gradientToColors: ['#00b5b5'],
                    inverseColors: true,
                    opacityFrom: 1,
                    opacityTo: 1,
                    stops: [0, 100]
                },
            },
            stroke: {
                lineCap: 'round'
            },
            chart: {
                sparkline: {
                    enabled: true,
                },
                dropShadow: {
                    enabled: true,
                    blur: 3,
                    left: 1,
                    top: 1,
                    opacity: 0.1
                },
            },
        }
    },
    supportTrackerRadialBar: {
        chartData: {
            totalTickets: 163,
            openTickets: 103,
            lastResponse: '1d',
        },
        series: [83],
        chartOptions: {
            plotOptions: {
                radialBar: {
                    size: 150,
                    offsetY: -40,
                    startAngle: -150,
                    endAngle: 150,
                    hollow: {
                        size: '65%',
                    },
                    track: {
                        background: "rgba(0,0,0,0)",
                        strokeWidth: '100%',

                    },
                    dataLabels: {
                        value: {
                            offsetY: 30,
                            color: '#99a2ac',
                            fontSize: '2rem'
                        }
                    }
                },
            },
            colors: ['#EA5455'],
            fill: {
                type: 'gradient',
                gradient: {
                    // enabled: true,
                    shade: 'dark',
                    type: 'horizontal',
                    shadeIntensity: 0.5,
                    gradientToColors: ['#7367F0'],
                    inverseColors: true,
                    opacityFrom: 1,
                    opacityTo: 1,
                    stops: [0, 100]
                },
            },
            stroke: {
                dashArray: 8
            },
            chart: {
                sparkline: {
                }
            },
            labels: ['Completed Tickets'],
        }
    },
    // RADAR
    statisticsRadar: {
        series: [{
            name: 'Visits',
            data: [90, 50, 86, 40, 100, 20],
        }, {
            name: 'Sales',
            data: [70, 75, 70, 76, 20, 85],
        }],
        chartOptions: {
            labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
            dataLabels: {
                style: {
                    colors: ['#b9c3cd', '#b9c3cd', '#b9c3cd', '#b9c3cd', '#b9c3cd', '#b9c3cd']
                }
            },
            yaxis: {
                show: false,
            },
            grid: {
                show: false,
            },
            legend: { show: false },
            chart: {
                dropShadow: {
                    enabled: true,
                    blur: 8,
                    left: 1,
                    top: 1,
                    opacity: 0.2
                },
                toolbar: {
                    show: false
                }
            },
            stroke: {
                width: 0
            },
            colors: ['#9f8ed7', '#1edec5'],
            plotOptions: {
                radar: {
                    polygons: {
                        strokeColors: ['#e8e8e8', 'transparent', 'transparent', 'transparent', 'transparent', 'transparent'],
                        connectorColors: 'transparent'
                    }
                }
            },
            fill: {
                type: 'gradient',
                gradient: {
                    shade: 'dark',
                    gradientToColors: ['#8e9ad6', '#1fcadb'],
                    shadeIntensity: 1,
                    type: 'horizontal',
                    opacityFrom: 1,
                    opacityTo: 1,
                    stops: [0, 100, 100, 100]
                },
            },
            markers: {
                size: 0,
            },
        }
    },
    // SessionsByDevice
    sessionsByDeviceDonut: {
        analyticsData: [
            { device: 'Dekstop', icon: 'MonitorIcon', color: 'primary', sessionsPercentgae: 58.6, comparedResultPercentage: 2 },
            { device: 'Mobile', icon: 'SmartphoneIcon', color: 'warning', sessionsPercentgae: 34.9, comparedResultPercentage: 8 },
            { device: 'Tablet', icon: 'TabletIcon', color: 'danger', sessionsPercentgae: 6.5, comparedResultPercentage: -5 },
        ],
        comparedResult: [2, -3, 8],
        series: [58.6, 34.9, 6.5],
        chartOptions: {
            labels: ['Desktop', 'Mobile', 'Tablet'],
            dataLabels: {
                enabled: false
            },
            legend: { show: false },
            chart: {
                offsetY: 30,
                type: 'donut',
                toolbar: {
                    show: false
                }
            },
            stroke: { width: 0 },
            colors: ['#7961F9', '#FF9F43', '#EA5455'],
            fill: {
                type: 'gradient',
                gradient: {
                    gradientToColors: ['#9c8cfc', '#FFC085', '#f29292']
                }
            }
        }
    },
    // Product Orders
    productOrdersRadialBar: {
        analyticsData: [
            { 'orderType': 'Finished', 'counts': 23043, color: 'primary' },
            { 'orderType': 'Pending', 'counts': 14658, color: 'warning' },
            { 'orderType': 'Rejected ', 'counts': 4758, color: 'danger' },
        ],
        series: [70, 52, 26],
        chartOptions: {
            labels: ['Finished', 'Pending', 'Rejected'],
            plotOptions: {
                radialBar: {
                    size: 165,
                    offsetY: -25,
                    hollow: {
                        size: '20%'
                    },
                    track: {
                        background: "#ebebeb",
                        strokeWidth: '100%',
                        margin: 15,
                    },
                    dataLabels: {
                        show: true,
                        name: {
                            fontSize: '18px',
                        },
                        value: {
                            fontSize: '16px',
                            color: "#636a71",
                            offsetY: 11
                        },
                        total: {
                            show: true,
                            label: 'Total',
                            formatter: function() {
                                return 42459
                            }
                        }
                    }
                },
            },
            responsive: [{
                breakpoint: 576,
                options: {
                    plotOptions: {
                        radialBar: {
                            size: 150,
                            hollow: {
                                size: '20%'
                            },
                            track: {
                                background: "#ebebeb",
                                strokeWidth: '100%',
                                margin: 15,
                            },
                        }
                    }
                }
            }],
            colors: ['#7961F9', '#FF9F43', '#EA5455'],
            fill: {
                type: 'gradient',
                gradient: {
                    // enabled: true,
                    shade: 'dark',
                    type: 'vertical',
                    shadeIntensity: 0.5,
                    gradientToColors: ['#9c8cfc', '#FFC085', '#f29292'],
                    inverseColors: false,
                    opacityFrom: 1,
                    opacityTo: 1,
                    stops: [0, 100]
                },
            },
            stroke: {
                lineCap: 'round'
            },
            chart: {
                dropShadow: {
                    enabled: true,
                    blur: 3,
                    left: 1,
                    top: 1,
                    opacity: 0.1
                },
            }
        }
    },
    // Customers
    customersPie: {
        analyticsData: [
            { 'customerType': 'New', 'counts': 890, color: 'primary' },
            { 'customerType': 'Returning', 'counts': 258, color: 'warning' },
            { 'customerType': 'Referrals ', 'counts': 149, color: 'danger' },
        ],
        series: [690, 258, 149],
        chartOptions: {
            labels: ['New', 'Returning', 'Referrals'],
            dataLabels: {
                enabled: false
            },
            legend: { show: false },
            chart: {
                type: 'pie',
                offsetY: 0,
                dropShadow: {
                    enabled: false,
                    blur: 5,
                    left: 1,
                    top: 1,
                    opacity: 0.2
                },
                toolbar: {
                    show: false
                }
            },
            stroke: {
                width: 5
            },
            colors: ['#7961F9', '#FF9F43', '#EA5455'],
            fill: {
                type: 'gradient',
                gradient: {
                    gradientToColors: ['#9c8cfc', '#FFC085', '#f29292']
                }
            }
        }
    },
    // Sales monthly
    salesLine: {
        series: [{
            name: "Sales",
            data: [140, 180, 150, 205, 160, 295, 125, 255, 205, 305, 240, 295]
        }],
        chartOptions: {
            chart: {
                toolbar: { show: false },
                dropShadow: {
                    enabled: true,
                    top: 20,
                    left: 2,
                    blur: 6,
                    opacity: 0.20
                }
            },
            stroke: {
                curve: 'smooth',
                width: 4,
            },
            grid: {
                borderColor: '#ebebeb',
            },
            legend: {
                show: false,
            },
            colors: ['#df87f2'],
            fill: {
                type: 'gradient',
                gradient: {
                    shade: 'dark',
                    inverseColors: false,
                    gradientToColors: ['#7367F0'],
                    shadeIntensity: 1,
                    type: 'horizontal',
                    opacityFrom: 1,
                    opacityTo: 1,
                    stops: [0, 100, 100, 100]
                },
            },
            markers: {
                size: 0,
                hover: {
                    size: 5
                }
            },
            xaxis: {
                labels: {
                    style: {
                        cssClass: 'text-grey fill-current',
                    }
                },
                axisTicks: {
                    show: false,
                },
                categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                axisBorder: {
                    show: false,
                },
            },
            yaxis: {
                tickAmount: 5,
                labels: {
                    style: {
                        cssClass: 'text-grey fill-current',
                    },
                    formatter: function(val) {
                        return val > 999 ? (val / 1000).toFixed(1) + 'k' : val;
                    }
                }
            },
            tooltip: {
                x: { show: false }
            }
        }
    },
    // ClientRetention Bar Chart
    clientRetentionBar: {
        series: [{
            name: 'New Clients',
            data: [175, 125, 225, 175, 160, 189, 206, 134, 159, 216, 148, 123]
        }, {
            name: 'Retained Clients',
            data: [-144, -155, -141, -167, -122, -143, -158, -107, -126, -131, -140, -137]
        }],
        chartOptions: {
            grid: {
                borderColor: '#ebebeb',
                padding: {
                    left: 0,
                    right: 0
                }
            },
            legend: {
                show: false,
            },
            dataLabels: {
                enabled: false
            },
            chart: {
                stacked: true,
                type: 'bar',
                toolbar: { show: false },
            },
            colors: ['#7367F0', '#EA5455'],
            plotOptions: {
                bar: {
                    columnWidth: '10%'
                }
            },
            xaxis: {
                labels: {
                    style: {
                        cssClass: 'text-grey fill-current',
                    }
                },
                axisTicks: {
                    show: false,
                },
                categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                axisBorder: {
                    show: false,
                },
            },
            yaxis: {
                tickAmount: 5,
                labels: {
                    style: {
                        cssClass: 'text-grey fill-current',
                    }
                }
            },
            tooltip: {
                x: { show: false }
            },
        }
    },
    // OTHER
    browserAnalytics: [{
            id: 1,
            name: 'Google Chrome',
            ratio: 73,
            time: 'Mon Dec 10 2018 07:46:05 GMT+0000 (GMT)',
            comparedResult: '800'
        },
        {
            id: 3,
            name: 'Opera',
            ratio: 8,
            time: 'Mon Dec 10 2018 07:46:05 GMT+0000 (GMT)',
            comparedResult: '-200'
        },
        {
            id: 2,
            name: 'Firefox',
            ratio: 19,
            time: 'Mon Dec 10 2018 07:46:05 GMT+0000 (GMT)',
            comparedResult: '100'
        },
        {
            id: 4,
            name: 'Internet Explorer',
            ratio: 27,
            time: 'Mon Dec 10 2018 07:46:05 GMT+0000 (GMT)',
            comparedResult: '-450'
        },
    ],
    mixedChart: {
        series: [{
           name: 'Rate of Sale per Week',
           type: 'column',
           categories: ['Product 1', 'Product 2', 'Product 3', 'Product 4', 'Product 5', 'Product 6', 'Product 7', 'Product 8', 'Product 9', 'Product 10', 'Product 11', 'Product 12', 'Product 13', 'Product 14', 'Product 15', 'Product 16', 'Product 17', 'Product 18', 'Product 19', 'Product 20', 'Product 21', 'Product 22', 'Product 23', 'Product 24', 'Product 25', 'Product 26', 'Product 27', 'Product 28', 'Product 29', 'Product 30', 'Product 31', 'Product 32', 'Product 33', 'Product 34', 'Product 35', 'Product 36', 'Product 37', 'Product 38'],
           data: [573, 490, 551, 495, 781, 385, 591, 862, 305, 129, 572, 708, 543, 146, 928, 905, 972, 958, 285, 234, 631, 534, 640, 568, 843, 453, 638, 921, 342, 137, 653, 776, 605, 204, 1005, 986, 981, 1019]
         }, {
           name: 'Stock In Hand',
           type: 'area',
           categories: ['Product 1', 'Product 2', 'Product 3', 'Product 4', 'Product 5', 'Product 6', 'Product 7', 'Product 8', 'Product 9', 'Product 10', 'Product 11', 'Product 12', 'Product 13', 'Product 14', 'Product 15', 'Product 16', 'Product 17', 'Product 18', 'Product 19', 'Product 20', 'Product 21', 'Product 22', 'Product 23', 'Product 24', 'Product 25', 'Product 26', 'Product 27', 'Product 28', 'Product 29', 'Product 30', 'Product 31', 'Product 32', 'Product 33', 'Product 34', 'Product 35', 'Product 36', 'Product 37', 'Product 38'],
           data: [157, 973, 248, 827, 577, 926, 884, 854, 658, 407, 746, 198, 804, 426, 115, 217, 185, 902, 715, 289, 251, 982, 322, 874, 656, 944, 973, 904, 734, 507, 789, 274, 837, 461, 208, 219, 233, 986]
         }, {
           name: 'Stock Insight',
           type: 'line',
           categories: ['Under Stock', 'Optimum Stock', 'Under Stock', 'Optimum Stock', 'Under Stock', 'Over Stock', 'Optimum Stock', 'OOS', 'Optimum Stock', 'Over Stock', 'Optimum Stock', 'Under Stock', 'Under Stock', 'Over Stock', 'Under Stock', 'Under Stock', 'Under Stock', 'OOS', 'Over Stock', 'OOS', 'Under Stock', 'Optimum Stock', 'Under Stock', 'Optimum Stock', 'Under Stock', 'Over Stock', 'Optimum Stock', 'OOS', 'Optimum Stock', 'Over Stock', 'Optimum Stock', 'Under Stock', 'Under Stock', 'Over Stock', 'Under Stock', 'Under Stock', 'Under Stock', 'OOS'],
           data: [157, 973, 248, 827, 577, 926, 884, 854, 658, 407, 746, 198, 804, 426, 115, 217, 185, 902, 715, 289, 251, 982, 322, 874, 656, 944, 973, 904, 734, 507, 789, 274, 837, 461, 208, 219, 233, 986]
           // data: ['Product 1', 'Product 2', 'Product 3', 'Product 4', 'Product 5', 'Product 6', 'Product 7', 'Product 8', 'Product 9', 'Product 10', 'Product 11', 'Product 12', 'Product 13', 'Product 14', 'Product 15', 'Product 16', 'Product 17', 'Product 18', 'Product 19', 'Product 20', 'Product 21', 'Product 22', 'Product 23', 'Product 24', 'Product 25', 'Product 26', 'Product 27', 'Product 28', 'Product 29', 'Product 30', 'Product 31', 'Product 32', 'Product 33', 'Product 34', 'Product 35', 'Product 36', 'Product 37', 'Product 38']
           // data: [{x:1,y:157},{x:2,y:973},{x:3,y:248},{x:4,y:827},{x:5,y:577},{x:6,y:926},{x:7,y:884},{x:8,y:854},{x:9,y:658},{x:10,y:407},{x:11,y:746},{x:12,y:198},{x:13,y:804},{x:14,y:426},{x:15,y:115},{x:16,y:217},{x:17,y:185},{x:18,y:902},{x:19,y:715},{x:20,y:289},{x:21,y:251},{x:22,y:982},{x:23,y:322},{x:24,y:874},{x:25,y:656},{x:26,y:944},{x:27,y:973},{x:28,y:904},{x:29,y:734},{x:30,y:507},{x:31,y:789},{x:32,y:274},{x:33,y:837},{x:34,y:461},{x:35,y:208},{x:36,y:219},{x:37,y:233},{x:38,y:986}]
         }],
         chartOptions: {
           colors: themeColors,
           // colors: ['#ff9e43', '#03a9f4', '#01e396'],
           chart: {
             stacked: false,
             animations: {
               initialAnimation: {
                 enabled: false
               }
             }
           },
           stroke: {
             width: [0, 1, 1],
             curve: 'smooth'
           },
           plotOptions: {
             bar: {
               columnWidth: '25%'
             }
           },
     
           fill: {
             opacity: [0.85, 0.25, 1],
             gradient: {
               inverseColors: false,
               shade: 'light',
               type: "vertical",
               opacityFrom: 0.85,
               opacityTo: 0.55,
               stops: [0, 100, 100, 100]
             }
           },
           // labels: ['Product 1', 'Product 2', 'Product 3', 'Product 4', 'Product 5', 'Product 6', 'Product 7', 'Product 8', 'Product 9', 'Product 10', 'Product 11', 'Product 12', 'Product 13', 'Product 14', 'Product 15', 'Product 16', 'Product 17', 'Product 18', 'Product 19', 'Product 20', 'Product 21', 'Product 22', 'Product 23', 'Product 24', 'Product 25', 'Product 26', 'Product 27', 'Product 28', 'Product 29', 'Product 30', 'Product 31', 'Product 32', 'Product 33', 'Product 34', 'Product 35', 'Product 36', 'Product 37', 'Product 38'
           // ],
           markers: {
             size: [0, 0, 3]
           },
           xaxis: {
             // categories: ['Product 1', 'Product 2', 'Product 3', 'Product 4', 'Product 5', 'Product 6', 'Product 7', 'Product 8', 'Product 9', 'Product 10', 'Product 11', 'Product 12', 'Product 13', 'Product 14', 'Product 15', 'Product 16', 'Product 17', 'Product 18', 'Product 19', 'Product 20', 'Product 21', 'Product 22', 'Product 23', 'Product 24', 'Product 25', 'Product 26', 'Product 27', 'Product 28', 'Product 29', 'Product 30', 'Product 31', 'Product 32', 'Product 33', 'Product 34', 'Product 35', 'Product 36', 'Product 37', 'Product 38']
           },
           yaxis: [{
             title: {
               text: 'Stock ( units )',
             },
             min: 0
           }, {
             title: {
               text: "Rate of Sale per Week ( Units )"
             },
             opposite: true,
           }],
           tooltip: {
             //   custom: function ({ series, seriesIndex, dataPointIndex, w }) {
             //     let label = ['UnderStock', 'Optimum Stock', 'UnderStock', 'Optimum Stock', 'UnderStock', 'Over Stock', 'Optimum Stock', 'OOS', 'Optimum Stock', 'Over Stock', 'Optimum Stock', 'UnderStock', 'underStock', 'Over Stock', 'underStock', 'underStock', 'underStock', 'OOS', 'Over Stock', 'OOS', 'UnderStock', 'Optimum Stock', 'UnderStock', 'Optimum Stock', 'UnderStock', 'Over Stock', 'Optimum Stock', 'OOS', 'Optimum Stock', 'Over Stock', 'Optimum Stock', 'UnderStock', 'underStock', 'Over Stock', 'underStock', 'underStock', 'underStock', 'OOS'];
             //     return (
             //         '<div class="custom-tooltip">' +
             //         '<div class="group">' +
             //         '<div>Stock Assortment</div>' +
             //         '<div class="group1">Rate of Sale: ' +
             //         series[0][dataPointIndex] +
             //         '</div>' +
             //         '<div class="group2">Stock In Hand: ' +
             //         series[1][dataPointIndex] +
             //         '</div>' +
             //         '</div>' +
             //         '<div class="group">' +
             //         '<div class="hilite"><span class="lite">' +
             //         label[dataPointIndex]+
             //         // tooltipInfo(data[0].itemSold[dataPointIndex], 'Items') +
             //         '</span> <br />' +
             //         // tooltipInfo(data[0].saleReason[dataPointIndex], 'Reason') +
             //         '</div>' +
             //         '</div>' +
             //         '</div>'
             //     );
             // },
             // shared: true,
             // intersect: false,
             // y: {
             //     formatter: function(y) {
             //         if (typeof y !== "undefined") {
             //             return y.toFixed(0) +' units';
             //         }
             //         return y;
     
             //     }
             // },
             custom: function ({ series, seriesIndex, dataPointIndex, w }) {
     
               function colorCode(type) {
                 if (type === 'OOS') {
                   return "color:red; font-size:30px";
                 } else if (type === 'Under Stock') {
                   return "color:orange;";
                 } else if (type === 'Over Stock') {
                   return "color:orange; font-size:30px";
                 } else {
                   return "color:green";
                 }
               }
     
               return (
                 '<div class="custom-tooltip">' +
                 '<div class="group">' +
                 '<div><span>' + w.config.series[0].categories[dataPointIndex] + '</span> <br />' +
                 '</div>' +
                 '<div class="group1">Expected Sale per Week: ' +
                 '<strong>' + series[0][dataPointIndex] + '</strong>' +
                 '</div>' +
                 '<div class="group1">Stock In Hand: ' +
                 '<strong>' + series[1][dataPointIndex] + '</strong>' +
                 '</div>' +
                 '</div>' +
                 '<div class="group">' +
                 '<h5 style="' + colorCode(w.config.series[2].categories[dataPointIndex]) + '">' + w.config.series[2].categories[dataPointIndex] + '</h5>' +
                 '</div>' +
                 '</div>' +
                 '</div>'
               );
             }
           }
         }
       },
       scatterChart: {
         series: [{
           name: "Discount Analysis",
           categories: ['Product 1', 'Product 2', 'Product 3', 'Product 4', 'Product 5', 'Product 6', 'Product 7', 'Product 8', 'Product 9', 'Product 10', 'Product 11', 'Product 12', 'Product 13', 'Product 14', 'Product 15', 'Product 16', 'Product 17', 'Product 18', 'Product 19', 'Product 20', 'Product 21', 'Product 22', 'Product 23', 'Product 24', 'Product 25', 'Product 26', 'Product 27', 'Product 28', 'Product 29', 'Product 30', 'Product 31', 'Product 32', 'Product 33', 'Product 34', 'Product 35', 'Product 36', 'Product 37', 'Product 38'],
           data: [
             [157,573],
             [973,490],
             [248,551],
             [827,495],
             [577,781],
             [926,385],
             [884,591],
             [854,862],
             [658,305],
             [407,129],
             [746,572],
             [198,708],
             [804,543],
             [426,146],
             [115,928],
             [217,905],
             [185,972],
             [902,958],
             [715,285],
             [289,234],
             [251,631],
             [982,534],
             [322,640],
             [874,568],
             [656,843],
             [944,453],
             [973,638],
             [904,921],
             [734,342],
             [507,137],
             [789,653],
             [274,776],
             [837,605],
             [461,204],
             [208,1005],
             [219,986],
             [233,981],
             [986,1019]
           ]
         }],
         chartOptions: {
           colors: themeColors,
           annotations: {
             position: 'front',
             yaxis: [
               {
                 y: 600,
                 borderColor: "#2698FF",
                 label: {
                   borderColor: "#2698FF",
                   style: {
                     color: "#fff",
                     background: "#2698FF"
                   },
                   text: "Discount"
                 }
               }
           ],
           xaxis: [
             {
               // in a datetime series, the x value should be a timestamp, just like it is generated below
               x: 500,
               strokeDashArray: 0,
               borderColor: "#2698FF",
               label: {
                 borderColor: "#2698FF",
                 style: {
                   color: "#fff",
                   background: "#2698FF"
                 },
                 text: "Rate of Sale"
               }
             }
           ],
        //    points: [
        //      {
        //        x: 745,
        //        y: 1000,
        //        marker: {
        //          size: 10,
        //          fillColor: "#00E396",
        //          strokeColor: "#00E396",
        //          radius: 10
        //        },
        //        label: {
        //          borderColor: "#00E396",
        //          offsetY: 0,
        //          style: {
        //            color: "#fff",
        //            background: "#00E396"
        //          },
       
        //          text: "Optimal Discount"
        //        }
        //      }, {
        //        x: 255,
        //        y: 1000,
        //        marker: {
        //          size: 5,
        //          fillColor: "#FF4560",
        //          strokeColor: "#FF4560",
        //          radius: 10
        //        },
        //        label: {
        //          borderColor: "#FF4560",
        //          offsetY: 0,
        //          style: {
        //            color: "#fff",
        //            background: "#FF4560"
        //          },
       
        //          text: "Under Discount"
        //        }
        //      }, {
        //        x: 255,
        //        y: 150,
        //        marker: {
        //          size: 3,
        //          fillColor: "#FF4560",
        //          strokeColor: "#FF4560",
        //          radius: 10
        //        },
        //        label: {
        //          borderColor: "#FF4560",
        //          offsetY: 0,
        //          style: {
        //            color: "#fff",
        //            background: "#FF4560"
        //          },
       
        //          text: "Idle Discount"
        //        }
        //      }, {
        //        x: 745,
        //        y: 150,
        //        marker: {
        //          size: 20,
        //          fillColor: "#FF4560",
        //          strokeColor: "#FF4560",
        //          radius: 10
        //        },
        //        label: {
        //          borderColor: "#FF4560",
        //          offsetY: 0,
        //          style: {
        //            color: "#fff",
        //            background: "#FF4560"
        //          },
       
        //          text: "Over Discount"
        //        }
        //      }
        //    ]
           },
           chart: {
             zoom: {
               enabled: true,
               type: 'xy'
             },
             toolbar: {
               show: true,
               autoSelected: 'zoom'
           }
           },
           dataLabels: {
             enabled: false
           },
           fill: {
             type: 'solid',
           },
           markers: {
             size: [10]
           },
           grid: {
             show: false
           },
           xaxis: {
             // offsetY: -200,
             axisTicks: {
               show: false,
             },
             axisBorder: {
               show: false,
               color: '#008FFB'
             },
             labels: {
               show: false,
               style: {
                 color: '#008FFB',
               }
             },
             title: {
               show: false,
               // text: "Inventory",
               style: {
                 color: '#008FFB',
               }
             },
             tooltip: {
               enabled: true
             },
             tickAmount: 8,
           },
           yaxis: {
             opposite: true,
             axisTicks: {
               show: false,
             },
             axisBorder: {
               show: false,
               color: '#008FFB'
             },
             labels: {
               show:false,
               style: {
                 color: '#008FFB',
               }
             },
             title: {
               show: false,
               // text: "Rate of Sale / Week",
               style: {
                 color: '#008FFB',
               }
             },
             tooltip: {
               enabled: true
             }
           }
         }
       },
       radialBarChart: {
        series: [10, 40, 20, 30],
        chartOptions: {
          colors: themeColors,
          plotOptions: {
            radialBar: {
              dataLabels: {
                name: {
                  fontSize: '22px',
                },
                value: {
                  fontSize: '16px',
                },
                total: {
                  show: true,
                  label: 'Total',
                  formatter: function(w) {
                    // By default this function returns the average of all series. The below is just an example to show the use of custom formatter function
                    return 1000
                  }
                }
              }
            }
          },
          labels: ['FMG', 'SMG', 'MMG', 'Obsolete'],
        }
      },
      donutChart: {
        series: [10, 40, 20, 30],
        chartOptions: {
          labels: ['FMG ( 100 units ~ Price Optimize )', 'SMG ( 400 units ~ Bundling )', 'MMG ( 200 units ~ Price Optimize )', 'Obsolete ( 300 units ~ Promotions )'],  
          colors: themeColors,
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }]
        }
    },
    revenueComparisonLineDemo: {
        series: [{
          name: "Actual",
          data: [34192345, 36034234, 34556768, 37003454, 34323123]//, 1261, 1149, 1283, 1019, 1064, 1054, 1014]
        },
        {
          name: "Predicted",
          data: [35192345, 36434234, 34856768, 37103454, 35223123, 38023435] //, 1019, 1064, 1054, 1014, 1115, 1103, 1209, 1020, 1196]
        }
        ],
        chartOptions: {
          
          chart: {
            toolbar: { show: false },
          },
          stroke: {
            curve: 'smooth',
            dashArray: [0, 8],
            width: [4, 2],
          },
          grid: {
            borderColor: '#e7e7e7',
          },
          legend: {
            show: false,
          },
          colors: ['#F97794', '#b8c2cc'],
          fill: {
            type: 'gradient',
            gradient: {
              shade: 'dark',
              inverseColors: false,
              gradientToColors: ['#7367F0', '#b8c2cc'],
              shadeIntensity: 1,
              type: 'horizontal',
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100, 100, 100]
            },
          },
          markers: {
            size: 0,
            hover: {
              size: 5
            }
          },
          xaxis: {
            labels: {
              style: {
                cssClass: 'text-grey fill-current',
              }
            },
            axisTicks: {
              show: false,
            },
            // categories: ["Jan '18", "Feb '18", "Mar '18", "Apr '18", "May '18", "Jun '18", "Jul '18", "Aug '18", "Sep '18", "Oct '18", "Nov '18", "Dec '18", "Jan '19", "Feb '19", "Mar '19", "Apr '19", "May '19"],
            // categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar", "Apr", "May"],
            categories: ["Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan"],
            axisBorder: {
              show: false,
            },
          },
          yaxis: {
            tickAmount: 5,
            labels: {
              style: {
                cssClass: 'text-grey fill-current',
              },
              formatter: function (val) {
                return val > 999 ? (val / 1000).toFixed(1) + 'k' : val;
              }
            }
          },
          tooltip: {
            shared: true,
            intersect: false,
            // x: { show: false }
          }
        }
      },
        // RADIAL BAR
  goalOverviewRadialBar: {
    series: [97],
    chartOptions: {
        plotOptions: {
            radialBar: {
                size: 110,
                startAngle: -150,
                endAngle: 150,
                hollow: {
                    size: '77%',
                },
                track: {
                    background: "#bfc5cc",
                    strokeWidth: '50%',
                },
                dataLabels: {
                    name: {
                        show: false
                    },
                    value: {
                        offsetY: 18,
                        color: '#99a2ac',
                        fontSize: '4rem'
                    }
                }
            }
        },
        colors: ['#00db89'],
        fill: {
            type: 'gradient',
            gradient: {
                shade: 'dark',
                type: 'horizontal',
                shadeIntensity: 0.5,
                gradientToColors: ['#00b5b5'],
                inverseColors: true,
                opacityFrom: 1,
                opacityTo: 1,
                stops: [0, 100]
            },
        },
        stroke: {
            lineCap: 'round'
        },
        chart: {
            sparkline: {
                enabled: true,
            },
            dropShadow: {
                enabled: true,
                blur: 3,
                left: 1,
                top: 1,
                opacity: 0.1
            },
        },
    }
},

}
